import { z } from 'zod'
import { createEInvoiceBuyerSchema } from './einvoice-buyer-schemas'
import { m } from '@/lib/paraglide/messages'

export function createEInvoiceDraftSchema() {
    return z
        .object({
            invoice_buyer: createEInvoiceBuyerSchema(),
            invoice_date: z.iso.date(m.einvoice_draft_date_invalid()),
            items: z.array(
                z.object({
                    line_number: z.number().int(),
                    item_name: z
                        .string()
                        .trim()
                        .min(1, m.einvoice_draft_name_required()),
                    discount_percent: z
                        .number({ error: m.einvoice_draft_discount_invalid() })
                        .min(0, m.einvoice_draft_discount_invalid())
                        .max(100, m.einvoice_draft_discount_invalid()),
                    vat_amount: z
                        .number({ error: m.einvoice_draft_vat_invalid() })
                        .int(m.einvoice_draft_vat_invalid())
                        .min(0, m.einvoice_draft_vat_invalid()),
                    // A removed line is hidden and dropped from the invoice on save.
                    removed: z.boolean(),
                }),
            ),
        })
        .refine(
            ({ items }) =>
                items.length === 0 || items.some((item) => !item.removed),
            {
                path: ['items'],
                message: m.einvoice_draft_lines_required(),
            },
        )
}
export type EInvoiceDraftValues = z.infer<
    ReturnType<typeof createEInvoiceDraftSchema>
>
